import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { HttpClient } from '@angular/common/http';
import { HttpHelperService } from 'src/app/core/services/http-helper.service';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/services/globals.service";
import * as i2 from "../../../core/services/http-helper.service";
import * as i3 from "@angular/common/http";
import * as i4 from "../../../core/services/ls-helper.service";
export class AccountService extends BaseProvider {
    constructor(globals, httpHelper, http, ls) {
        super();
        this.globals = globals;
        this.httpHelper = httpHelper;
        this.http = http;
        this.ls = ls;
        this.roles = [];
        this.showManagement = false;
        this.itemToEdit = {};
        this.profiles = [];
        this.menu = [];
        this.selectedProfile = null;
        this.selectedMenu = null;
        this.baseUrl = 'userProfile';
    }
    getById(id) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/' + id;
            const loginData = this.ls.get('loginData');
            this.http.get(this.url)
                .subscribe((data) => {
                this.itemToEdit = data.Data;
                resolve(this.itemToEdit);
            }, err => { reject(err); });
        });
    }
    getRoles() {
        return new Promise((resolve, reject) => {
            if (this.roles.length > 0) {
                resolve(this.roles);
            }
            this.url = this.globals.dataUrl + this.baseUrl + '/roles';
            this.http
                .get(this.url)
                .subscribe((data) => {
                this.roles = data;
                resolve(data);
            }, (error) => {
                // console.log(error);
                reject(error);
            });
        });
    }
    searchUsers(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/term/' + params.term +
                '/page/' + params.pageNumber +
                '/size/' + params.pageSize;
            this.http
                .get(this.url)
                .subscribe((data) => {
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    getUser(id) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/' + id;
            this.http
                .get(this.url)
                .subscribe((data) => {
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    getUserByUserId() {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl;
            this.http
                .get(this.url)
                .subscribe((data) => {
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    createUser(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl;
            this.http
                .post(this.url, params)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    updateUser(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/' + params.Id;
            this.http
                .put(this.url, params)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    changePassword(newPassword) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/password';
            this.http
                .post(this.url, { Password: newPassword })
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    uploadImage(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/file';
            this.http
                .post(this.url, params)
                .subscribe((data) => {
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    updateEmail(params) {
        return new Promise((resolve, reject) => {
            this.url = `${this.globals.dataUrl}${this.baseUrl}/email`;
            this.http
                .put(this.url, params)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
}
AccountService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AccountService_Factory() { return new AccountService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpHelperService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(i4.LsHelperService)); }, token: AccountService, providedIn: "root" });
